export default __webpack_public_path__ + "static/media/text-right.d9aca544.svg";